module.exports = __webpack_public_path__ + "img/page-14.6d7688e4.jpg";